import { SvgIcon as MuiSvgIcon, SvgIconProps as MuiSvgIconProps } from "@mui/material";

export const BackToTopIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props}>
    <path
      d="M15.9419 13.0581L12.4419 9.55806C12.1979 9.31398 11.8021 9.31398 11.5581 9.55806L8.05806 13.0581C7.81398 13.3021 7.81398 13.6979 8.05806 13.9419C8.30214 14.186 8.69786 14.186 8.94194 13.9419L12 10.8839L15.0581 13.9419C15.3021 14.186 15.6979 14.186 15.9419 13.9419C16.186 13.6979 16.186 13.3021 15.9419 13.0581Z"
      fill="var(--gravx-color-neutral-on-light-grey-7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 7.71979 7.71979 4.25 12 4.25C16.2802 4.25 19.75 7.71979 19.75 12Z"
      fill="var(--gravx-color-neutral-on-light-grey-7)"
    />
  </MuiSvgIcon>
);
